'use strict'

// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// A sample component

const Slider = {
    init: function () {
        if (document.querySelector('.swiper-container')) {
            Swiper.use([Navigation, Pagination]);

            var swiper1 = new Swiper('.js-slider-img', {
                spaceBetween: 10,
                slidesPerView: 'auto',
                grabCursor: true,
                noSwiping: false,
                freeMode: true,
                freeModeMomentumVelocityRatio: 0.5,
                navigation: {
                    nextEl: '.slider-button-next',
                    prevEl: '.slider-button-prev',
                },
                breakpoints: {
                    991: {
                        slidesPerView: 'auto',
                        spaceBetween: 5,
                    },
                }
            });

            var swiper2 = new Swiper('.js-slider-text-img', {
                spaceBetween: 10,
                slidesPerView: 1,
                grabCursor: true,
                noSwiping: false,
                freeMode: true,
                freeModeMomentumVelocityRatio: 0.5,
                navigation: {
                    nextEl: '.slider-button-next',
                    prevEl: '.slider-button-prev',
                },
                breakpoints: {
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                }
            });

        }
    },


}


export default Slider;
